import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import NotarySection from 'modules/_shared/components/NotarySection';
import CommentsCharCounter from 'modules/_shared/components/CommentsCharCounter';
import UploadDocument from 'modules/documents/components/UploadDocument';
import { useCapitalDecreaseModal } from '../context/CapitalDecreaseModalContext';

const CapitalDecreaseScriptureView: FC = () => {
  const { t } = useTranslate();

  const MAX_DATE = '2100-01-01';
  const MAX_COMMENT_LENGTH = 500;

  const { data, actions } = useCapitalDecreaseModal();
  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="capital-decrease-date">
          {t('Date')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <input
            id="capital-decrease-date"
            type="date"
            className="form-control form-control-lg"
            value={data.date}
            onChange={actions.handleChangeDate}
            required
            max={MAX_DATE}
            min={data.lastOperationDate}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="shares-to-decrease">
          {t('NºInvokedParticipations')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <NumberFormat
            id="shares-to-decrease"
            className="form-control form-control-lg"
            placeholder={t('NºInvokedParticipations')}
            value={data.totalSharesToDecrease}
            onChange={actions.handleChangeTotalSharesToDecrease}
            required
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...numberFormat}
          />
        </div>
        <span className="form-label text-primary">
          {t('TotalParticipationsAvaila', {
            societyShares: data.societyActualShares,
          })}
        </span>
      </div>

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <div className="form-group">
        <label className="form-label" htmlFor="capital-decrease-comments">
          {t('CommentsLabel')}
        </label>
        <div className="form-control-wrap">
          <div className="form-editor-custom">
            <textarea
              id="capital-decrease-comments"
              maxLength={500}
              className="form-control form-control-lg no-resize"
              value={data.comments}
              onChange={actions.handleChangeComments}
            />
          </div>
        </div>

        <div className="form-note d-flex justify-content-between">
          <>{t('CommentsVisibleOnlyAdmins')}</>
          <CommentsCharCounter
            comments={data.comments}
            maxLength={MAX_COMMENT_LENGTH}
          />
        </div>
      </div>

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.onChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.onChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.onChangeNotaryCity}
          lgSize
        />
      </div>
    </>
  );
};

export default CapitalDecreaseScriptureView;
